var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.104,
    height: 12.104,
    viewBox: "0 0 12.104 12.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2282",
    "data-name": "Group 2282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2281",
    "data-name": "Group 2281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M5.33,0a5.33,5.33,0,1,0,5.33,5.33A5.337,5.337,0,0,0,5.33,0Zm0,9.677A4.346,4.346,0,1,1,9.677,5.33,4.351,4.351,0,0,1,5.33,9.677Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2284",
    "data-name": "Group 2284",
    transform: "translate(8.299 8.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2283",
    "data-name": "Group 2283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M354.707,354.011l-2.821-2.821a.492.492,0,0,0-.7.7l2.821,2.821a.492.492,0,0,0,.7-.7Z",
    transform: "translate(-351.046 -351.046)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.2b43f621da4d1530b0009f0efa5c25a2.svg";
export { ForwardRef as ReactComponent };